import { useFormContext } from 'react-hook-form';

import { type RecurringExamEventCreationFormType } from './schema';
function useRecurringExamEventCreationForm() {
  const context = useFormContext<RecurringExamEventCreationFormType>();

  if (!context) {
    throw new Error(
      'useRecurringExamEventCreationForm must be used within a RecurringExamEventCreationFormProvider',
    );
  }

  return context;
}

export { useRecurringExamEventCreationForm };
